export {
  default,
  getDatesOfYear,
  getWeeksOfYear,
  getMonthsOfYear,
  getYearsOfLife,
  stepupMilestonePeriodDate,
  periodGoalDates,
  getPeriodDate,
  isItBeforeToday,
  threshold,
  getTimelineEntryPeriod,
  getTimelineEntryDate,
} from '@routine-notes/ui/utils/getDates';
